import {PropsWithChildren, createContext, useState} from 'react';

const INITIAL_PROPS = {
  selectedIds: {},
  setSelectedIds: (_: {[key: string]: boolean}) => {},
};

  type ContextType = {
    selectedIds: {[key: string]: boolean}
    setSelectedIds: (ids: {[key: string]: boolean}) => void,
  }

export const SelectedIdsContext = createContext<ContextType>(INITIAL_PROPS);

export const SelectedIdsContextProvider = ({children}: PropsWithChildren) => {
  const [selectedIds, setSelectedIds] = useState<{[key: string]: boolean}>({});


  return (
    <SelectedIdsContext.Provider value={{
      selectedIds,
      setSelectedIds,
    }}>
      {children}
    </SelectedIdsContext.Provider>
  );
};

